var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#2B6638"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.365 4.135a.714.714 0 0 1 .147.978l-5.396 7.6a.664.664 0 0 1-.984.121L4.24 10.317a.715.715 0 0 1-.081-.986.664.664 0 0 1 .955-.083l2.337 2.035 4.966-6.996a.664.664 0 0 1 .947-.15z",
  clipRule: "evenodd"
})));
export default SvgSuccess;